import React from "react";
import { useAuthDataContext } from "../../components/auth-provider";
import { Button } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import { useHistory } from "react-router-dom";


export const LogoutPage = () => {
    const { onLogout } = useAuthDataContext();
    const history = useHistory();

    return <div style={{ marginTop: '100px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

        <p>Deseja realmente sair?</p>
        <Container maxWidth="lg">
            <Box mt={3}>

                <Button
                    style={{ padding: '8px' }}
                    fullWidth
                    variant="contained"
                    color="primary" onClick={() => history.push('/dashboard')}>Não, ir para Dashboard</Button>

                <Button
                    style={{ padding: '8px' , marginTop:'20px'}}
                    fullWidth
                    variant="contained"
                    color="secondary" onClick={onLogout}>Sim, voltar para tela de login</Button>

            </Box>
        </Container>


    </div>;
};
